import React, { useState, useEffect} from 'react';
import axios from 'axios';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';


const countries = [ "Algeria","Afghanistan","Angola","Argentina","Australia","Austria","Belgium","Bolivia","Brazil","Bulgaria","Canada","Chile","China","Columbia","Congo","Czech Republic","Denmark","France","Germany","Indonesia","Italy","Laos","Madagascar","Mexico","Morocco","Namibia","Norway","Other Origin","Pakistan","Russia","South Africa","Tanzania","United States","Uruguay","Zambia","Peru","India","Spain"]
const min_stone_color = [ "Black","Blue","Brown","Gold","Green","Grey","Orange","Pink","Purple","Rainbow","Red","White","Yellow","Transparent","Smoky","Clear","Fluorescent","Silver"]
const product_type = ["Aventurine","Green Aventurine","Blue Aventurine","Pink Man-Made Quartz","Red Man-Made Quartz","Blue Man-Made Quartz","Clear Man-Made Quartz","Yellow Man-Made Quartz","Man-Made Opal","Man-Made Topaz","Paradoxides Fossil","Mosasaur Tooth Fossil","Orthocera Fossil","Coprolite Fossil","Fish Fossil","Crocodile Tooth Fossil","Ammonite Fossil","Amethyst Geode","Tanzanite","Amazonite","Smoky Quartz","Rutilated Quartz","Rose Quartz","Prehnite Quartz","Clear Quartz","Celestite","Malachite","Spinel","Balochistan Fluorite","Hemimorphite","Labradorite","Morocco Vanadinite","Calcite","Multicolor Calcite","Orange Calcite","White Calcite","Quartz Calcite","Fujian Calcite","Red Calcite","Green Calcite","Blue Calcite","Clear Calcite","Cobalto Calcite","Stalactite Stalagmite Calcite","Leiping Calcite","Yellow Calcite","Sodalite","Skutterudite","Galena","Astrophyllite","Petrified Wood","Peridot","Atacamite","Plumbogummite","Brochantite","Aquamarine","Heulandite","Jade","Yellow Jade","Chalcedony","Agate","Carnelian","Grape Agate","Tourmaline","Colored Tourmaline","Black Tourmaline","Muscovite","Dolomite","Howlite","White Howlite","Scheelite","Cerussite","Garnet","Spessartine Garnet","Lab Quartz","Green Calcite Fluorite","Chrysocolla","Sulfur","Jasper","Dalmatian Jasper","Red Jasper","Pyrrhotite","Pyromorphite","Apatite","Emerald","Vesuvianite","Amethyst","Banded Amethyst","Veracruz Amethyst","Kunzite","Ruby","Unakite","Epidote","Turquoise","White Turquoise","Chrysoprase","Onyx","Chrysanthemum Stone","Siderite","Rhodochrosite","Fluorite","Inner Mongolia Fluorite","Tanzanite Fluorite","Rainbow Fluorite","Manaoshan Fluorite","Yaogangxian Fluorite","Purple Fluorite","Green Fluorite","botryoidal fluorite","Blue Fluorite","Clear Fluorite","Xianghualing Fluorite","Sapphire","Kyanite","Azurite","Rhodonite","Red Tiger eye","Blue Tiger eye","Golden Tiger eye","Serpentine","Opal","Bloodstone","Hematite","Pyrolusite","Stilbite","Selenite","Barite","GoldStone","Orange GoldStone","Red GoldStone","Blue GoldStone","Black GoldStone","Goethite","Vanadinite","Autunite","Wolframite","Erythrite","Wulfenite","Iron Ore","Fuchsite","Lepidolite","Zircon","Rosasite","Feldspar","Sphalerite","Alabaster","Aragonite","Lapis Lazuli","Citrine","Topaz","Pyrite","Spain Pyrite","Chalcopyrite Peacock Ore","Mahogany Obsidian","Black Obsidian","Red Obsidian","Snowflake Obsidian","Septarian","Yellow Agate","Crazy Agate"," Glaucophane","Qinghai Jade","Kambaba Jasper","Rainbow Labradorite","Silver Labradorite"]
const product_shape = ["Single point","Double point","Angel","Apple","Bear","Bird","Cat","Cube","Deer","Dinosaur","Dog","Dragon","Eagle","Egg","Elephant","Horse","Heart","Mouse","Natural","Oblisk","Diamond octahedron","Owl","Pig","Pipe","Palm stone","Pyramid","Rabbit","Skull","Sphere","Tiger","Turtle","Unicorn","Massage wand","Bracelet","Necklace","Lotus","Slabs","Yoni Ball","Tower","Massage Roller"]

function EditDraftPage(){
    const [formData, setFormData] = useState({empty: 'true'});
    const [searchSku, setSearchSku] = useState({ password: '', SKU: '' });
    const [status, setStatus] = useState("Waiting");
    const [skuData, setSkuData] = useState({});
    const [files, setUploadFile] = useState({});
    var buttonName = "";

    // when deployed, if error presents itself, it may be because we have to set state vars for the MST, MC, ORC, ORS
    useEffect(() => {
	    axios.get('https://flamingyetis.com/lookupDrafts')
	    .then(function (response) {
	      console.log(response);
	      setSkuData(response);
	      //const countries = response.data.countries; 
	    })
	    .catch(function (err) {
	      console.log(err);
	    });
    }, []);

    const handleChangeFiles = (event) => {
      setUploadFile(event.target.files);
    }

    const getProduct = () => {
        axios({
          method: "GET",
          url: "https://flamingyetis.com/lookup",
          params: {
              "password": searchSku.password,
              "SKU": searchSku.sku
          },
          //headers: { "Content-Type": "application/json" },
        })
          .then(function (response) {
            setFormData({});  // Resets form data when new product is requested
            setFormData(response.data);
            console.log(formData);
          })
          .catch(function (response) {
            console.log(response);
          });
      }

    const handleSubmitSearch = (event) => {
        event.preventDefault();
        getProduct();
    }
    const processPics = (strPics) => {
      if (strPics !== undefined){
        if (strPics.length == 0){
          return "No picture"
        }
        var listPics = strPics.split(",");
        let imgs = [];
        let i = 0;
        for (i = 0; i < listPics.length; i++){
          imgs.push(<img key={listPics[i] + "key"}  src={listPics[i]} alt="Picture of mineral" width="50" height="50" className="img-fluid"/>);
          if (i === 1){
            return imgs;
          }
        }  
        return imgs;    
      }
      return "Empty pic list";
    } 

    const handleDelete = (SKU) => {
      console.log(JSON.stringify({"SKU": SKU}));
      axios({
        method: "POST",
        url: "https://flamingyetis.com/deleteDrafts",
        data: JSON.stringify({"SKU": SKU}),
        headers: { "Content-Type": "application/json" },
         })
           .then(function (response) {
             console.log(response);
             window.location.reload(false);
           })
           .catch(function (response) {
             console.log(response);
           });
    }

    const renderRow = (rowInfo) => {
      return(
        <tr>
          <td key={rowInfo[0] + "sku"}>{rowInfo[0]}</td>
          <td key={rowInfo[0] + "img"}>{processPics(rowInfo[4])}</td>
          <td key={rowInfo[0] + "mbn"}>{rowInfo[1]}</td>
          <td key={rowInfo[0] + "location"}>{rowInfo[7]}</td>
          <td key={rowInfo[0] + "boxnumber"}>{rowInfo[6]}</td>
          <td key={rowInfo[0] + "delete"}><button className="button-86" onClick={() => {handleDelete(rowInfo[0]);}}>KILL</button></td>
        </tr>
      )
    }

    const handleChangeSearch = (event) => {
        setSearchSku({ ...searchSku, [event.target.name]: event.target.value });
    }

    const sendUpdateDraft = () => {

        const formDataFULL = new FormData();

        for (let i = 0 ; i < files.length ; i++) {
          formDataFULL.append("files", files[i]);
        }
    
        for (let i = 0; i < Object.keys(formData).length; i++){
          formDataFULL.append(Object.keys(formData)[i], formData[Object.keys(formData)[i]]);
        }
        //console.log(Object.keys(formData));
    
        //console.log(formDataFULL.getAll("files"));
        for (var value of formDataFULL.values()) {
          console.log(value);
       }
        axios({
            method: "POST",
            url: "https://flamingyetis.com/update-drafts",
            data: formDataFULL,
            headers: { "Content-Type":  "multipart/form-data"}
          })
        .then(function (response) {
            alert(response.data.updated);
            console.log(response);
            setStatus(response.data.updated);
//          window.location.reload(false);     //comment out this line to debug
          })
          .catch(function (response) {
            console.log(response);
          });
    }
    const sendUpdateProduct = () => {
      const formDataFULL = new FormData();

      for (let i = 0 ; i < files.length ; i++) {
        formDataFULL.append("files", files[i]);
      }

      for (let i = 0; i < Object.keys(formData).length; i++){
        formDataFULL.append(Object.keys(formData)[i], formData[Object.keys(formData)[i]]);
      }
      //console.log(Object.keys(formData));

      //console.log(formDataFULL.getAll("files"));
      for (var value of formDataFULL.values()) {
        console.log(value);
    }
      axios({
          method: "POST",
          url: "https://flamingyetis.com/update-products",
          data: formDataFULL,
          headers: { "Content-Type":  "multipart/form-data"}
      })
      .then(function (response) {
          alert(response.data.updated);
          console.log(response);
          setStatus(response.data.updated);
//          window.location.reload(false);     //comment out this line to debug
        })
        .catch(function (response) {
          console.log(response);
        });
  }

    const handleSubmitForm = (event) => {
        event.preventDefault();
        //checking for buttons
        if (buttonName === "draft-button"){
          console.log("draft-button");
          sendUpdateDraft();
        }
        else if (buttonName === "complete-button"){
          console.log("complete-button");
          sendUpdateProduct();
        }
    }

    const handleChange = (event) => {
        setFormData({ ...formData, [event.target.name]: event.target.value });
    }


//    const renderAutocompletePlatform = (Platdata) => {
//      if (typeof Platdata.platform !== "undefined"){
//        const tempArr = Platdata.platform.split(",")
//        return (
//          <Autocomplete multiple id="platform" name="platform" value={formData.plat} defaultValue={tempArr} options={["Ebay", "Etsy",  "Amazon"]} renderInput={(params) => <TextField {...params} size="small" label="Platforms" />} onChange={(event, newValue) => {setFormData({ ...formData, "platform": newValue })}} />
//        )
//      }else{
//        return ("Loading")
//      }
//    }

    const renderAutocompleteFields = (allData, idName) => {
      if (idName === "mineral-stone-color" && (typeof allData.s_col !== "undefined" || allData.found  === "Drafts")){
        return(
          <Autocomplete autoSelect freeSolo id="mineral-stone-color" defaultValue={formData.s_col} options={min_stone_color} renderInput={(params) => <TextField {...params} label="Mineral Stone Color" size="small"/>} name="mineral-stone-color"  value={formData.s_col}  onChange={(event, newValue) => {setFormData({ ...formData, "s_col": newValue })}}/>
        )
      }else if (idName === "origin-secondary" && (typeof allData.or_s !== "undefined" || allData.found  === "Drafts")){
        return(
        <Autocomplete autoSelect freeSolo id="origin-secondary" defaultValue={formData.or_s} options={countries} renderInput={(params) => <TextField {...params} label="Origin Secondary" size="small"/>} name="origin-secondary" value={formData.or_s} onChange={(event, newValue) => {setFormData({ ...formData, "or_s": newValue })}} />
        )
      }else if (idName === "origin-country" && (typeof allData.or_c !== "undefined" || allData.found  === "Drafts")){
        return(
        <Autocomplete id="origin-country" defaultValue={formData.or_c} options={countries} renderInput={(params) => <TextField {...params} label="Origin" size="small"/>} name="origin-country" value={formData.or_c} onChange={(event, newValue) => {setFormData({ ...formData, "or_c": newValue })}} />
        )
      }else if (idName === "mineral-stone-type" && (typeof allData.mst !== "undefined" || allData.found  === "Drafts")){
        return(
          <Autocomplete freeSolo autoSelect id="mineral-stone-type" defaultValue={formData.mst} options={product_type} renderInput={(params) => <TextField {...params} size="small" label="Mineral Stone Type" />} name="mineral-stone-type" value={formData.min_stone_type} onChange={(event, newValue) => {setFormData({ ...formData, "mst": newValue })}} />
        )

      }else if(idName === "mineral-stone-shape" && (typeof allData.mss !== "undefined" || allData.found  === "Drafts")){
        return(
          <Autocomplete freeSolo autoSelect id="mineral-stone-shape" defaultValue={formData.mss} options={product_shape} renderInput={(params) => <TextField {...params} size="small" label="Mineral Stone Shape" />} name="mineral-stone-shape" value={formData.min_stone_shape} onChange={(event, newValue) => {setFormData({ ...formData, "mss": newValue })}} />
        )
      }else{
        return ("Loading")
      }

    }



    /*const renderAutocompleteMSC = (MSCdata) => {
      if (typeof MSCdata.)
    }*/

    const renderForm = (props) => {
        return (
            <div>
                <form onSubmit={handleSubmitForm}>
        <div className="container">
          <h1>Locco Decor Product Edit Section</h1>
          <button className="button-85" onSubmit={handleSubmitForm} onClick={() => {buttonName= "draft-button"}} >save to draft</button>
          <button className="button-85" onsubmit={handleSubmitForm} onClick={() => {buttonName= "complete-button"}} >Submit to Sellbrite </button>

          <div className="row">
            <div className="col-md-4 mb-3">
              <label>Password</label>
              <input type="text" className="form-control" id="password" name="password" placeholder="Password" value={formData.password} onChange={handleChange} required />
            </div>
            <div className="col-md-4 mb-3">
                <label>Mineral Batch Number</label>
                <input type="text" className="form-control" id="mineral-batch-number" name="mbn" placeholder="Mineral Batch Number" defaultValue={formData.mbn} onChange={handleChange} required/>
            </div>
            <div className="col-md-4 mb-3">
                <label>SKU</label>
                <input type="text" className="form-control" id="sku" placeholder="SKU" name="sku" value={formData.sku} onChange={handleChange} required />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 mb-3">
              <label>Invoice Payment</label>
              <select className="form-control custom-select" id="payment" name="payment" onChange={handleChange}>
                <option value="Paid" selected={formData.payment==="Paid" ? "True" : "False"}>Paid</option>
                <option value="Unpaid" selected={formData.payment==="Unpaid" ? "True" : "False"}>Unpaid</option>
              </select>
            </div>
            <div className="col-md-4 mb-3">
                <label>Stone Category</label>
                <select className="form-control custom-select" id="stone-category" name="s_cat" onChange={handleChange}>
                  <option value="Specimen" selected={formData.s_cat==="Specimen" ? "True" : "False"}>Specimen</option>
                  <option value="Polished" selected={formData.s_cat==="Polished" ? "True" : "False"}>Polished</option>
                  <option value="Material" selected={formData.s_cat==="Material" ? "True" : "False"}>Material</option>
                  <option value="Jewelry" selected={formData.s_cat==="Jewelry" ? "True" : "False"}>Jewelry</option>
                  <option value="livesale" selectede={formData.s_cat==="livesale" ? "True" : "False"}>Livesale</option>
                  <option value="Other" selected={formData.s_cat==="Other" ? "True" : "False"}>Other</option>
                </select>
            </div>
            <div className="col-md-4 mb-3">
              <label>Mineral Stone Color</label>
              {renderAutocompleteFields(formData, "mineral-stone-color")}
            </div>
            </div>
            <div className="row">
            <div className="col-md-6 mb-3">
              <label>Mineral Stone Type</label>
              {renderAutocompleteFields(formData, "mineral-stone-type")}
            </div>
            <div className="col-md-6 mb-3">
              <label>Mineral Stone Shape</label>
              {renderAutocompleteFields(formData, "mineral-stone-shape")}
            </div>
          </div>
          <div className="row">
          <div className="col-md-6 mb-3">
              <label>Brief Description 描述</label>
              <input type="text" className="form-control" id="brief-description" placeholder="description" name="brief_description" value={formData.brief_description} onChange={handleChange}/>
            </div>
            <div className="col-md-6 mb-3">
              <label>Description</label>
              <textarea className="form-control" id="description" placeholder="Description" name="des" defaultValue={formData.des} onChange={handleChange}/>
            </div>
            <div className="col-md-6 mb-3">
              <label>Title</label>
              <textarea className="form-control" id="title" placeholder="Title" name="title" defaultValue={formData.title} onChange={handleChange}/>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label>Video Link</label>
              <input type="text" className="form-control" id="vl" placeholder="Video Link" name="vl" defaultValue={formData.vl} onChange={handleChange}/>
            </div>
            <div className="col-md-6 mb-3">
              <label>Picture Links</label>
              <input type="text" className="form-control" id="img_h" placeholder="Picture Links" name="img_h" defaultValue={formData.img_h} onChange={handleChange}/>
            </div>
          </div>
          <div className='row'>
            <label>File Upload</label>
            <input type="file" className="form-control" id="files" name="files" multiple accept="image/png, image/jpeg, image/jpg, video/*" onChange={handleChangeFiles}></input>
          </div>
          <div className="row">
            <div className="col-md-3 mb-3">
              <label>Available Stock</label>
              <input type="number" className="form-control" id="available-stock" name="a_stock" placeholder="Stock" defaultValue={formData.a_stock} onChange={handleChange} />
            </div>
            <div className="col-md-3 mb-3">
                <label>Origin Country</label>
                {renderAutocompleteFields(formData, "origin-country")}
            </div>
            <div className="col-md-3 mb-3">
              <label>Origin Secondary</label>
              {renderAutocompleteFields(formData, "origin-secondary")}
            </div>
            <div className="col-md-3 mb-3">
              <label>Mineral Grade</label>
              <select className="form-control custom-select" id="mineral-grade" name="min_g" onChange={handleChange}>
                  <option value="A" selected={formData.min_g==="A" ? "True" : "False"}>Grade A</option>
                  <option value="B" selected={formData.min_g==="B" ? "True" : "False"}>Grade B</option>
                  <option value="C" selected={formData.min_g==="C" ? "True" : "False"}>Grade C</option>
                  <option value="D" selected={formData.min_g==="D" ? "True" : "False"}>Grade D</option>
                  <option value="E" selected={formData.min_g==="E" ? "True" : "False"}>Grade E</option>
                  <option value="" selected={formData.min_g==="" ? "True" : "False"}> </option>
                </select>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 mb-3">
              <label>Length(cm)</label>
              <input type="number" step="0.01" min="0" className="form-control" id="length-cm" name="l_cm" placeholder="Length(cm)" defaultValue={formData.l_cm} onChange={handleChange}/>
            </div>
            <div className="col-md-3 mb-3">
              <label>Width(cm)</label>
              <input type="number" step="0.01" min="0" className="form-control" id="width-cm" name="w_cm" placeholder="Width(cm)" defaultValue={formData.w_cm} onChange={handleChange}/>
            </div>
            <div className="col-md-3 mb-3">
              <label>Height(cm)</label>
              <input type="number" step="0.01" min="0" className="form-control" id="height-cm" name="h_cm" placeholder="Height(cm)" defaultValue={formData.h_cm} onChange={handleChange}/>
            </div>
            <div className="col-md-3 mb-3">
              <label>Weight(g)</label>
              <input type="number" step="0.01" min="0" className="form-control" id="weight-g" name="wt_g" placeholder="Weight(g)" defaultValue={formData.wt_g} onChange={handleChange}/>
            </div>
          </div>
        </div>
        <div className="container">
          <h1>Price related</h1>
          <div className="row">
            <div className="col-md-4 mb-3">
              <label>Cost</label>
              <input type="number" step="0.01" min="0" className="form-control" id="cost" name="cost" placeholder="Cost" defaultValue={formData.cost} onChange={handleChange}/>
            </div>
            <div className="col-md-4 mb-3">
              <label>Cost/kg</label>
              <input type="number" step="0.01" min="0" className="form-control" id="cost_kg" name="cost_kg" placeholder="Cost/kg" defaultValue={formData.cost_kg} onChange={handleChange}/>
            </div>
            <div className="col-md-4 mb-3">
              <label>Wholesale Price</label>
              <input type="number" step="0.01" min="0" className="form-control" id="wholesale-price" name="w_price" placeholder="Wholesale Price" defaultValue={formData.w_price} onChange={handleChange}/>
            </div>
            </div>
            <div className="row">
            <div className="col-md-6 mb-3">
              <label>Wholesale Price/kg</label>
              <input type="number" step="0.01" min="0" className="form-control" id="wholesale-price-kg" name="w_p_kg" placeholder="Wholesale Price/kg" defaultValue={formData.w_p_kg} onChange={handleChange} />
            </div>
            <div className="col-md-6 mb-3">
              <label>Price</label>
              <input type="number" step="0.01" min="0" className="form-control" id="price" name="price" placeholder="Price" defaultValue={formData.price} onChange={handleChange}/>
            </div>
          </div>
        </div>
        <div className="container">
          <h1>Location</h1>
          <div className="row">
            <div className="col-md-4 mb-3">
              <label>Box Number</label>
              <input type="text" className="form-control" id="box-number" name="min_boxnum" placeholder="Box Number" defaultValue={formData.min_boxnum} onChange={handleChange}/>
            </div>
            <div className="col-md-4 mb-3">
              <label>Locations</label>
              <input type="text" className="form-control" id="locations" name="min_loc" placeholder="Locations" defaultValue={formData.min_loc} onChange={handleChange}/>
            </div>
          </div>
        </div>
                  <button className="button-85" onSubmit={handleSubmitForm} onClick={() => {buttonName= "draft-button"}} >save to draft</button>
                  <button className="button-85" onsubmit={handleSubmitForm} onClick={() => {buttonName= "complete-button"}} >Submit to Sellbrite </button>
                  <h2>{status}</h2>
                </form>
            </div>
        )
    }

    return(
      //       return <input onChange={this.onInputChange} /> ;
      //        {/*-Value of the input: {this.state.term} */}

        <div className="container">
            <div className="container">
              {/* 
              <div> 
                <h1>SKU in Drafts | 草稿箱 SKU</h1>
                <h6><b>DRAFTS:</b>   You can use the SKU below, these SKUs are under Draft</h6><br></br>
                <h6><b>------草稿箱:</b>   下面草稿箱的SKU 可供参考</h6><br></br>
                <h6><b>Published:</b>   You can find the SKU somewhere and is still able to edit</h6><br></br>
                <h6><b>------已发布:</b>   需要自行查找SKU 方可编辑</h6>
              </div>
              */}
                <br/>
                <div className="scrolls">
                  <table className="table border">
                    <thead>
                      <tr>
                      <th scope="col">SKU</th>
                      <th scope="col">Img/图</th>
                      <th scope="col">Batch Number/批次</th>
                      <th scope="col">Location/位置</th>
                      <th scope="col">Box Number/盒子</th>
                      <th scope="col">X_X</th>
                      </tr>
                    </thead>
                    <tbody className="specialtbody">
                      {typeof skuData.data !== "undefined" ? skuData.data.sku_list.map(d => renderRow(d)) : null}
                    </tbody>
                  </table>
                </div>
                <br/>
                <br/>
                <br/>
            </div>
            <div className="container">
                <form onSubmit={handleSubmitSearch}>
                    <label>Password 密码</label>
                    <input type="text" className="form-control" id="password" name="password" placeholder="Password" value={searchSku.password} onChange={handleChangeSearch} required />
                    <label>SKU Number</label>
                    <input type="text" className="form-control" id="sku" name="sku" placeholder="Enter SKU to search" value={searchSku.sku} onChange={handleChangeSearch} required />
                    <br></br>
                  <button className="button-85" onSubmit={handleSubmitSearch}>submit/提交</button>
                </form>
            </div>
            <div className="container">
              <br></br>
                {formData.empty==="true" ? "Welcome to search function 欢迎查找" : formData.found==="not found" ? "Not Found Bro, 亲没找到哦！" : renderForm(formData)}
            </div>
        </div>

    )
}

export default EditDraftPage;
